/**
 * Scroll position shared by the two ways a screen change is triggered:
 * the router's `scrollBehavior` (page change) and `scrollToTop()` (screens that
 * share a single URL).
 *
 * `behavior: 'instant'` neutralises the global `html { scroll-behavior: smooth }`
 * (main.css), which would otherwise animate the jump on every screen.
 */
export const SCROLL_TOP = { top: 0, behavior: 'instant' } as const

/**
 * Brings the window back to the top of the page. Meant for the screens that are
 * NOT a route change — the « Tes informations » sub-steps all share the URL of
 * the quote — where the router's `scrollBehavior` never runs.
 */
export function scrollToTop(): void {
  if (typeof window === 'undefined') return
  window.scrollTo(SCROLL_TOP)
}
